<script>
  import { getNextInputId } from "../../helper/UIHelper";

  export let model;
  export let label;
  export let scheme;
export let hint;
export let inputNotRounded;
  let localModel = model;
  let className = "";

  const checkForHttp = scheme == "https://" || "http://";
  export { className as class };

  let uid = getNextInputId();

  function onChange() {
    /*Special case -> if scheme is https:// also check for http:// */
    if (checkForHttp) {
      if (localModel.startsWith("https://")) {
        localModel = localModel.replace("https://", "");
        scheme = "https://";
      } else if (localModel.startsWith("http://")) {
        localModel = localModel.replace("http://", "");
        scheme = "http://";
      }
    } else if (localModel.startsWith(scheme))
      localModel = localModel.replace(scheme, "");

    model = scheme + localModel;
  }

  $: localModel && onChange();
</script>

<div class={className}>
  {#if label != null}
    <label for={uid} class="block text-m font-medium leading-5 text-main mb-1">
      {label}
    </label>
  {/if}
  <div class="rounded-md shadow-sm flex">
    <span
      class="inline-flex items-center px-3 rounded-l-md border border-r-0
      border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
      {scheme}
    </span>
    <input
      bind:value={localModel}
      id={uid}
      type="text"
      on:blur
      class:rounded-r-md={!inputNotRounded}
      class="flex-1 form-input block w-full rounded-none transition
      duration-150 ease-in-out sm:text-m sm:leading-5" />
  </div>
  {#if hint != null}
    <div class="mt-1 text-xs text-gray-400">{hint}</div>
  {/if}
</div>
